export const friendsLocation = friend => ({
    type: 'FRIENDS_LOCATION_GET',
    payload: friend
})

export const friendsLocationMapObj = friend => ({
    type: 'FRIENDS_LOCATION_MAP_OBJ',
    payload: friend
})

export const removeFriendsLocationMapObj = () => ({
    type: 'REMOVE_FRIENDS_LOCATION_MAP_OBJ',
})

export const locationClearTimeOut = (timeInterval) => ({
    type: 'LOCATION_TIME_INTERVAL_SET',
    payload: timeInterval
})